
import { Tooltip} from "antd";
import { useTranslation } from "react-i18next";
import { Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  BorderColor as BorderColorIcon} from '@mui/icons-material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Hooks from "../../utils/hooks";
import { setOpenDelModal } from "../../store/GroupeRmBoxActions";
import "../../GroupeRmBox.scss";
import Detail from "../../Modal/Detail.modal";
import ProgramSchedule from "../../Modal/ProgramSchedule";
import { ModalConfirm } from "@empreinte/components.modal-confirm";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../Redux/hooks";

function useActionMenu({ record }: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { handleShowModal, handleEditGroupeRmBox,visible ,visiblePgm,handleCancel,handleShowProgramScheduleModal,deleteGroupeRmBox} = Hooks(); //deleteGroupeRmBox
  const [openModal,setOpenModal]=useState(false)
const isSuperAdmin = useAppSelector((state: any) => state.ReducerUserData.isSuperAdmin)
const { configuration_rmboxgroup_module } = useAppSelector((state: any) => state.ReducerUserData.modules)
  return (
    <div>
      <div className="action">
        {(configuration_rmboxgroup_module?.configuration_rmboxgroup_get_detail_action?.authorized || isSuperAdmin) && 
        <div has-permission="configuration_rmboxgroup_get_detail">
          <Tooltip placement="top" title={t("boitier.details")}>
            <VisibilityIcon className={"icon_action"} onClick={()=>handleShowModal(record?.id)} />
          </Tooltip>
        </div>}
        {(configuration_rmboxgroup_module?.configuration_rmboxgroup_post_edit_action?.authorized || isSuperAdmin) && 
        <div has-permission="configuration_rmboxgroup_post_edit">
          <Tooltip placement="top" title={t("boitier.edit")}>
            <BorderColorIcon
              className={"icon_action"}
              onClick={() => handleEditGroupeRmBox(record)}
            />
          </Tooltip>
        </div>}
        {(configuration_rmboxgroup_module?.configuration_rmboxgroup_delete_rmboxgroup_action?.authorized || isSuperAdmin) && 
        <div has-permission="configuration_rmboxgroup_delete_rmboxgroup">
          <Tooltip placement="top" title={t("boitier.delete")}>
            <DeleteIcon className={"icon_action"}  
                      onClick={() =>{
                               dispatch(setOpenDelModal(true));
                                setOpenModal(true)}}/>
          </Tooltip>
        </div>}
        {(configuration_rmboxgroup_module?.configuration_rmboxgroup_associate_schedule_no_api_action?.authorized || isSuperAdmin) && 
        <div has-permission="configuration_rmboxgroup_associate_schedule_no_api">
          <Tooltip placement="top" title={t("boitier.Rmboxgroup.pgmschedule")}>
            <CalendarTodayIcon className={"icon_action"} onClick={()=>handleShowProgramScheduleModal(record?.id)}/>
          </Tooltip>
        </div>}
          
        {/* Modal de confirmation avant suppression */}

       {openModal && (  
             <ModalConfirm
             className="deleteModal"
          
              open={openModal}
              onClose={()=>setOpenModal(false)}
              title={t('boitier.delete')}
              content={t('Zone.DeleteConfirmationOneDelete')}
              fullWidth={true}
              CancelBtnName={t('boitier.No')}
              ConfirmBtnName={t('boitier.Yes')}
              onCancel={()=>setOpenModal(false)}
              onConfirm={() => 
              {
                  deleteGroupeRmBox(record?.id)
                  dispatch(setOpenDelModal(false))
                  setOpenModal(false)
              }}
          />
          )}


        {/*Modal Details*/ }
        <Detail visible={visible} handleCancel={handleCancel}/>
        {/*Modal Details*/}
        {/*Modal Program schedule */}
        <ProgramSchedule visible={visiblePgm} handleCancel={handleCancel}/>
        {/*Modal Program schedule */}

      </div>
    </div>
  );
}

export default useActionMenu;
